import { useData } from "./DataContext.js";

import Badge from "react-bootstrap/Badge";

import MoneyFormat from "./MoneyFormat.js";

const style = { width: "160px", height: "28px" };
const className = "d-flex justify-content-center align-items-center ";
const textClassName = "fs-6 fw-medium ";

export default function InvestmentBar (props)
{
    const gData = useData();

    if (props.type === "state")
    {
	return (<Badge bg="dark" className={className + textClassName} style={style}><MoneyFormat value={gData.state.money} sign={false}/></Badge>);
    }

    if ((props.type === "result" && gData.state.currentThemeId !== null) || props.type === "inter-result")
    {
	let diff = 0;
	if (props.type === "result")
	{
	    const currentMoney = gData.state.themes[gData.state.currentThemeId].startMoney;
	    const endMoney = gData.state.themes[gData.state.currentThemeId].endMoney;
	    diff = endMoney - currentMoney;
	}

	else if (props.type === "inter-result")
	{
	    if (gData.state.solutions[gData.state.currentSolutionId].applied)
	    {
		const result = gData.state.reports[gData.state.currentSolutionId].result;
		diff = -result.investment.realCost;
		/* if (currentValue + diff > 100) diff = 100 - currentValue;
		   else if (currentValue + diff < 0) diff = currentValue; */
	    }
	}	

	return (
	    <div className="d-flex align-items-center gap-2">
		<Badge bg="dark" className={className + textClassName} style={style}><MoneyFormat value={gData.state.money} sign={false}/></Badge>
		{diff !== 0 && (<div className={"fs-6 fw-bold " + (diff > 0 ? "text-success" : "text-danger")}>(<MoneyFormat value={diff}/>)</div>)}
	    </div>
	);
    }

    else if (props.type === "analysis")
    {
	const report = gData.state.reports[props.solutionId];
	
	if (report.result === null)
	{
	    const cost = report.investment.documentIds.reduce((cost, documentId) => cost + gData.content.documents[documentId].cost, 0);
	    
	    if (cost === 0) return (<Badge bg="secondary" className={className + textClassName + "opacity-50"} style={style}>Aucun</Badge>);
	    else return (<Badge bg={cost <= 0 ? "success" : "danger"} className={className + textClassName} style={style}><MoneyFormat value={-cost}/></Badge>);		
	}

	else {
	    const investmentResult = report.result.investment;
	    
	    if (investmentResult.realCost === investmentResult.estCost && investmentResult.realCost === 0)
		return (<Badge bg="secondary" className={className + textClassName + "opacity-50"} style={style}>Aucun</Badge>);

	    else if (investmentResult.realCost === investmentResult.estCost && investmentResult.realCost !== 0)
		return (<Badge bg={investmentResult.realCost <= 0 ? "success" : "danger"} className={className + textClassName} style={style}><MoneyFormat value={-investmentResult.realCost}/></Badge>);
	    
	    else if (investmentResult.realCost !== investmentResult.estCost && investmentResult.estCost !== 0)
		return (<Badge bg="warning" className={className + textClassName + "text-dark"} style={style}><MoneyFormat value={-investmentResult.estCost}/></Badge>);
		
	    else return (<Badge bg="warning" className={className + "fs-7 fw-bold text-white"} style={style}>Données manquantes</Badge>);
	}
    }
    
    else if (props.type === "impact")
    {
	const report = gData.state.reports[props.solutionId];
	const investmentResult = report.result.investment;
	if (investmentResult.realCost === investmentResult.estCost && investmentResult.realCost === 0)
	    return (<Badge bg="dark" className={className + textClassName} style={style}><MoneyFormat value={gData.state.money} sign={false}/></Badge>);
	    
	else if (investmentResult.realCost === investmentResult.estCost && investmentResult.realCost !== 0)
	    return (<Badge bg="dark" className={className + textClassName} style={style}><MoneyFormat value={gData.state.money - investmentResult.realCost} sign={false}/></Badge>);
	
	else return (<Badge bg="secondary" className={className + "fs-7 fw-normal text-white"} style={style}>Données manquantes</Badge>);
    }

    else return (<></>);
}
